import React from "react";
import { Container } from "reactstrap";
import { Helmet } from 'react-helmet-async';
import Section from "./Section";
import EditFormSec from "./EditFormSec";

const EditCompany = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Update Company | Jobseekers Page </title>
      </Helmet>
      <Section />
      <section className="section">
        <Container>
          <EditFormSec />
        </Container>
      </section>
    </React.Fragment>
  );
};

export default EditCompany;
